export enum ConsultantTypes {
  GETALL = '@consultant/GETALL',
  GETALL_SUCCESS = '@consultant/GETALL_SUCCESS',
  GETALL_FAILED = '@consultant/GETALL_FAILED',
  CREATE = '@consultant/CREATE',
  CREATE_SUCCESS = '@consultant/CREATE_SUCCESS',
  CREATE_FAILED = '@consultant/CREATE_FAILED',
  CLEAR = '@consultant/CLEAR',
}
